// ✅ FİYAT GÜNCELLEME FONKSİYONU - VARIATION SEÇİLDİĞİNDE TETİKLENİR
function updatePrice(variationId) {
    if (!variationId || variationId === 0) return;
    
    // Global scope'da kayıtlı olan varyasyon listesini kontrol et
    if (!window.allVariations) {
        console.warn('window.allVariations bulunamadı.');
        return;
    }

    const variation = window.allVariations.find(v => v.variation_id === variationId);
    if (!variation) return;
    
    const container = document.getElementById('variant-price-container');
    const regularEl = document.getElementById('regular-price');
    const saleEl = document.getElementById('sale-price');
    
    if (!container || !regularEl || !saleEl) return;

    // HTML'deki data-currency attribute değerinden para birimini alıyoruz
    const currency = container.getAttribute('data-currency') || 'zł'; // Varsayılan yedek birim de ekleyebilirsin
    
    const regularPrice = variation.display_regular_price;
    const salePrice = variation.display_price;
    
    // Fiyatı formatlayan alt yardımcı fonksiyon
    function formatPrice(price) {
        return parseFloat(price).toFixed(2).replace('.', ',');
    }
    
    if (parseFloat(salePrice) < parseFloat(regularPrice)) {
        regularEl.style.display = 'inline';
        regularEl.innerHTML = formatPrice(regularPrice) + ' ' + currency;
        saleEl.innerHTML = formatPrice(salePrice) + ' ' + currency;
    } else {
        regularEl.style.display = 'none';
        saleEl.innerHTML = formatPrice(regularPrice) + ' ' + currency;
    }
}

// Fonksiyonu dışarıya (global pencereye) açıyoruz
window.updatePrice = updatePrice;